module.exports = __webpack_public_path__ + "img/MyTrip.bdae23a7.png";